import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface StickyBarProps {
  show: boolean;
  totalPrice: number;
}
export function StickyBar({
  show,
  totalPrice
}: StickyBarProps) {
  return <AnimatePresence data-id="element-330">
      {show && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3,
      ease: 'easeOut'
    }} style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: '#1C1C1E',
      borderTop: '2px solid #C9973A',
      padding: '12px 20px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      zIndex: 1000,
      boxShadow: '0 -8px 30px rgba(0,0,0,0.4)',
      flexWrap: 'wrap',
      gap: '10px'
    }} data-id="element-331">
          <div data-id="element-332">
            <p style={{
          fontFamily: "'Lato', sans-serif",
          fontSize: '11px',
          color: '#6A6A6A',
          margin: '0 0 1px',
          fontWeight: 700,
          textTransform: 'uppercase',
          letterSpacing: '1px'
        }} data-id="element-333">
              Precio especial de hoy
            </p>
            <p style={{
          fontFamily: "'Playfair Display', serif",
          fontSize: '18px',
          fontWeight: 900,
          color: '#C9973A',
          margin: 0
        }} data-id="element-334">
              Imperio Digital — Solo ${totalPrice.toFixed(2)}
            </p>
          </div>
          <a href="#precio" style={{
        textDecoration: 'none'
      }} data-id="element-335">
            <button style={{
          background: 'linear-gradient(135deg, #1B5E3B, #2D7A52)',
          color: '#fff',
          fontFamily: "'Lato', sans-serif",
          fontWeight: 900,
          fontSize: '13px',
          letterSpacing: '1px',
          padding: '12px 22px',
          borderRadius: '10px',
          border: '1px solid #C9973A',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '7px',
          whiteSpace: 'nowrap'
        }} data-id="element-336">
              COMPRAR AHORA — ${totalPrice.toFixed(2)}
              <ArrowRight size={15} data-id="element-337" />
            </button>
          </a>
        </motion.div>}
    </AnimatePresence>;
}